function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { productLstApi } from '@/api/product';
import store from '@/store';
export default {
  name: 'GoodList',
  props: {
    handleNum: {
      type: String,
      default: ''
    },
    checked: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      templateRadio: 0,
      props: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: false,
        emitPath: false
      },
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 10,
        cateId: '',
        keywords: '',
        type: 1,
        isExcludeCard: true,
        hasAttrValue: true
      },
      imgList: [],
      multipleSelection: [],
      checkedPage: [],
      isChecked: false,
      isIndex: 0,
      checkBox: [],
      merCateList: store.getters.merProductClassify,
      checkedIds: [] // 订单当前页选中的数据
    };
  },
  created: function created() {
    if (!localStorage.getItem('merProductClassify')) store.dispatch('product/getMerProductClassify');
  },
  computed: {},
  mounted: function mounted() {
    this.merCateList = store.getters.merProductClassify;
    this.getList();
    if (this.checked.length) {
      var _this$checked = _toArray(this.checked),
        arr2 = _arrayLikeToArray(_this$checked).slice(0);
      this.checkBox = arr2;
      this.checkedIds = arr2.map(function (item) {
        return item.id;
      });
    }
  },
  methods: {
    onInput: function onInput(e) {
      this.$forceUpdate();
    },
    changeType: function changeType(v) {
      this.isChecked = v;
      var index = this.checkedPage.indexOf(this.tableFrom.page);
      this.isIndex = index;
      this.checkedPage.push(this.tableFrom.page);
      if (index > -1) {
        this.checkedPage.splice(index, 1);
      }
      this.syncCheckedId(v);
    },
    changeOne: function changeOne(v, order) {
      if (v) {
        var index = this.checkedIds.indexOf(order.id);
        if (index === -1) {
          this.checkedIds.push(order.id);
          this.checkBox.push(order);
        }
      } else {
        var _index = this.checkedIds.indexOf(order.id);
        if (_index > -1) {
          this.checkedIds.splice(_index, 1);
          this.checkBox.splice(_index, 1);
        }
      }
    },
    syncCheckedId: function syncCheckedId(o) {
      var _this = this;
      var ids = this.tableData.data.map(function (v) {
        return v.id;
      });
      if (o) {
        this.tableData.data.forEach(function (item) {
          var index = _this.checkedIds.indexOf(item.id);
          if (index === -1) {
            _this.checkedIds.push(item.id);
            _this.checkBox.push(item);
          }
        });
      } else {
        this.tableData.data.forEach(function (item) {
          var index = _this.checkedIds.indexOf(item.id);
          if (index > -1) {
            _this.checkedIds.splice(index, 1);
            _this.checkBox.splice(index, 1);
          }
        });
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var tables = [];
      val.map(function (item) {
        tables.push({
          src: item.image,
          id: item.id
        });
      });
      this.multipleSelection = tables;
    },
    ok: function ok() {
      this.$emit('getStoreItem', this.checkBox);
    },
    getTemplateRow: function getTemplateRow(row) {
      this.$emit('getStoreItem', row);
    },
    getList: function getList(num) {
      var _this2 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      productLstApi(this.tableFrom).then(function (res) {
        _this2.tableData.data = res.list;
        _this2.tableData.total = res.total;
        // res.list.map((item) => {
        //   this.imgList.push(item.image)
        // })
        _this2.tableData.data.forEach(function (item) {
          _this2.checked.forEach(function (element) {
            if (Number(item.id) === Number(element.id)) {
              _this2.$nextTick(function () {
                _this2.$refs.multipleTable.toggleRowSelection(item, true);
              });
            }
          });
        });
        _this2.listLoading = false;
      }).catch(function (res) {
        _this2.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    }
  }
};